// routes
import { PATH_DASHBOARD } from '../routes/paths';
import { ADMIN_ROLE_SUPER } from '../constants/moduleAccess';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.analytics; // '/admin/analytics'
export const PATH_AFTER_LOGIN_SUPER_ADMIN = PATH_DASHBOARD.adminDashboard.root; // '/admin/adminDashboard'

/** Uses `admin.role` from localStorage (set after profile load). */
export function getPathAfterLogin() {
  try {
    const raw = window.localStorage.getItem('admin');
    if (raw) {
      const admin = JSON.parse(raw);
      if (admin?.role === ADMIN_ROLE_SUPER) return PATH_AFTER_LOGIN_SUPER_ADMIN;
    }
  } catch {
    /* ignore */
  }
  return PATH_AFTER_LOGIN;
}

// LAYOUT
// ----------------------------------------------------------------------
export const Image = process.env.REACT_APP_IMAGE_PATH;
export const PSMLOGO = process.env.REACT_APP_LOGO_PATH;
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 50,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 50,
};

export const IMAGE = process.env.IMAGE_DATA;

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 240,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 20,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: process.env.THEME_PRESET_COLOR || 'purple',
  themeLayout: 'horizontal',
  themeStretch: false,
};
